import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-apron-error',
  templateUrl: './apron-error.component.html',
  styleUrls: ['./apron-error.component.scss']
})
export class ApronErrorComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    document.body.classList.add('background');
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }
}
